import React, {useEffect, useState, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import axios from "axios";
import {getBaseUrl} from "../utils";
import ReactPlayer from "react-player";
import {FaPlay, FaPause, FaExpand} from "react-icons/fa";
import {Document, Page} from "react-pdf";

// Set local worker source
import {pdfjs} from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `/assates/pdf.worker.js`;


const MaterialDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const {material} = location.state || {};

    const [subjects, setSubjects] = useState([]);
    const [activeSubject, setActiveSubject] = useState(null);
    const [subjectName, setSubjectName] = useState(null);
    const baseUrl = getBaseUrl();
    const token = localStorage.getItem("userToken");
    const [playing, setPlaying] = useState(false);
    const [showPause, setShowPause] = useState(false);
    const videoRef = useRef(null);
    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);


    // Full-Screen Toggle Function
    // const handleFullScreen = () => {
    //   if (videoRef.current) {
    //     if (document.fullscreenElement) {
    //       document.exitFullscreen();
    //     } else if (videoRef.current.requestFullscreen) {
    //       videoRef.current.requestFullscreen();
    //     } else if (videoRef.current.webkitRequestFullscreen) { // Safari
    //       videoRef.current.webkitRequestFullscreen();
    //     } else if (videoRef.current.msRequestFullscreen) { // IE11
    //       videoRef.current.msRequestFullscreen();
    //     }
    //   }
    // };

    // useEffect(() => {
    //       if (!material) return;
    //     // Load YouTube script
    //     const tag = document.createElement("script");
    //     tag.src = "https://www.youtube.com/iframe_api";
    //     document.body.appendChild(tag);

    //     let player;

    //     window.onYouTubeIframeAPIReady = () => {
    //         const videoId = material?.youtubeLink;
    //         player = new window.YT.Player(videoRef.current, {
    //             height: "250",
    //             width: "100%",
    //             videoId: videoId, // ✅ dynamic here
    //             playerVars: {
    //                 autoplay: 1,
    //                 controls: 1,        // ✅ keep controls
    //                 modestbranding: 1,  // ✅ reduce logo
    //                 rel: 0,             // ✅ limit suggestions
    //                 iv_load_policy: 3,  // ✅ hide annotations
    //                 fs: 1,              // allow fullscreen (optional)
    //             },
    //             events: {
    //                 onReady: (event) => {
    //                     event.target.mute();      // autoplay fix
    //                     event.target.playVideo();
    //                 }
    //             }
    //         });
    //     };

    //     return () => {
    //         if (player) player.destroy();
    //     };
    // }, []);


    useEffect(() => {
    if (!material) return;

    // Don't initialize YouTube for PDFs
    if (material.fileType !== "Video") return;

    if (!material.youtubeLink) return;

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    let player;

    window.onYouTubeIframeAPIReady = () => {
        if (!videoRef.current) return;

        player = new window.YT.Player(videoRef.current, {
            height: "250",
            width: "100%",
            videoId: material.youtubeLink,
            playerVars: {
                autoplay: 1,
                controls: 1,
                modestbranding: 1,
                rel: 0,
                iv_load_policy: 3,
                fs: 1,
            },
            events: {
                onReady: (event) => {
                    event.target.mute();
                    event.target.playVideo();
                },
            },
        });
    };

    return () => {
        if (player) {
            player.destroy();
        }
    };
}, [material]); // change by pravas


    useEffect(() => {
        const fetchSubjects = async () => {
            try {
                const response = await axios.get(`${baseUrl}user_api/subjectList`, {
                    headers: {Authorization: `Bearer ${token}`},
                });

                if (response.data?.results) {
                    setSubjects(response.data.results);
                    const materialSubject = response.data.results.find(
                        (subject) => subject._id === material?.subjectId
                    );
                    if (materialSubject) {
                        setSubjectName(materialSubject.name);
                        setActiveSubject(materialSubject._id);
                    }
                }
            } catch (error) {
                console.error("Error fetching subjects:", error);
            }
        };

        fetchSubjects();
    }, [baseUrl, token, material]);

    const onDocumentLoadSuccess = ({numPages}) => {
        setNumPages(numPages);
    };

    const nextPage = () => {
        if (pageNumber < numPages) {
            setPageNumber(prev => prev + 1);
        }
    };

    const prevPage = () => {
        if (pageNumber > 1) {
            setPageNumber(prev => prev - 1);
        }
    };

    console.log('materialmaterialmaterialmaterialmaterialmaterial', material)

    if (!material) {
        return <p className="text-center mt-10 text-gray-500">No material data provided.</p>;
    }

    return (
        <div className="flex min-h-screen bg-gray-100">
            {/* Sidebar - Subject List */}
            <aside className="w-1/4 bg-gray-100 p-2 rounded-xl">
                <ul className="space-y-4">
                    {subjects.map((subject) => (
                        <li
                            key={subject._id}
                            className={`flex items-center p-2 rounded-lg cursor-pointer shadow-sm transition ${activeSubject === subject._id
                                ? "border-2 border-black bg-black text-white shadow-lg"
                                : "bg-white hover:shadow-md"
                            }`}
                            onClick={() => {
                                setActiveSubject(subject._id);
                                navigate("/dashboard/myMaterials", {state: {subject, subjectId: subject._id}});
                            }}
                        >
                            {/* Icon */}
                            <span className="w-8 h-8 flex items-center justify-center rounded-full mr-3 bg-gray-200">
                📚
              </span>
                            <span className="font-semibold">{subject.name}</span>
                        </li>
                    ))}
                </ul>
            </aside>

            {/* Main Content - Material Detail */}
            <div className="flex-1 p-2">
                <div className="bg-white shadow-sm rounded-lg p-6 max-w-2xl mx-auto relative">
                    {/* Back Button with Image */}
                    <button
                        className="absolute top-4 left-4 hover:bg-gray-300 rounded-full p-2 flex items-center justify-center w-10 h-10"
                        onClick={() => navigate(-1)}
                    >
                        <img src="/assates/left_arrow.png" alt="Back" className="w-3"/>
                    </button>

                    <div className="relative w-full rounded-lg overflow-hidden mt-8">
                        <div className="relative">

                            {material.fileType === "Video" ? (
                                    <div className="relative rounded-lg overflow-hidden">
                                        <div>
                                            <style>
                                                {`
      .action-menu-engagement-buttons-wrapper,
      .no-label-exp,
      .delhi-player,
      .quick-actions-wrapper.enable-rtl-mirroring {
        display: none !important;
      }
    `}
                                            </style>

                                            <div ref={videoRef}></div>
                                        </div>
                                    </div>
                                ) : (
                                <iframe
                                 src={`https://docs.google.com/gview?url=${material.files[0]}&embedded=true`}
        //                           src={`https://docs.google.com/gview?url=${encodeURIComponent(
        //     material.files?.[0] || ""
        // )}&embedded=true`}
                             width="100%"
                             height="500px"
                        />
                        )}
                    </div>
                </div>


                {/* Material Details */}
                <div className="mt-4">
                    <h1 className="text-xl font-semibold text-gray-900">{material.name}</h1>

                    {/* Description */}
                    <div className="mt-4">
                        <h2 className="text-lg font-medium text-gray-800">Description</h2>
                        <p className="text-gray-600 text-sm mt-2 leading-relaxed">
                <span
                    dangerouslySetInnerHTML={{
                        __html: material.description || "No description available.",
                    }}
                />
                        </p>
                    </div>

                    {/* Quick Notes Button */}
                    <div className="mt-6">
                        {/* <button className="w-full bg-black text-white py-2 rounded-lg text-center hover:bg-gray-800 transition">
                Quick Notes
              </button> */}
                    </div>
                </div>
            </div>
        </div>
</div>
)
    ;
};

export default MaterialDetail;
